<mat-toolbar class="social">
    <a class="compressed" href="https://groovemonkee.com/">SHOP</a>
    <a class="compressed" href="https://groovemonkee.com/blogs/news">BLOG</a>
    <a href="https://www.youtube.com/user/groovemonkeemidi?feature=mhee"><img [src]="'/img/social/youtube.png' | assetsUrl" /></a>
    <a href="https://www.facebook.com/pages/Groove-Monkee/131811956877298"><img [src]="'/img/social/facebook.png' | assetsUrl" /></a>
    <a href="https://twitter.com/groove_monkee"><img [src]="'/img/social/twitter.png' | assetsUrl" /></a>
</mat-toolbar>